import { useEffect, useRef, useState } from "react";
import { ReactComponent as NoImageIcon } from "../../assets/icons/image-not-found-icon.svg";

interface ISvgComponentProps {
	src: string;
	fill?: string;
	width?: number | string;
	height?: number | string;
}

const SvgComponent: React.FC<ISvgComponentProps> = ({ src, fill = "currentColor", width, height }) => {
	const containerRef = useRef<SVGSVGElement | null>(null);
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		const loadSvg = async () => {
			try {
				const response = await fetch(src);
				const text = await response.text();

				const parser = new DOMParser();
				const doc = parser.parseFromString(text, "image/svg+xml");
				const svgElement = doc.querySelector("svg");

				if (!svgElement) return;

				// Remove existing fills
				svgElement.querySelectorAll("[fill]").forEach((el) => el.removeAttribute("fill"));

				svgElement.setAttribute("fill", fill);

				if (width) svgElement.setAttribute("width", String(width));
				if (height) svgElement.setAttribute("height", String(height));

				// Replace previous svg if exists
				if (containerRef.current) {
					containerRef.current.replaceWith(svgElement);
					containerRef.current = svgElement as SVGSVGElement;
				}
			} catch (error) {
				setShowError(true);
			}
		};

		loadSvg();
	}, [src, fill, width, height]);

	if (showError) {
		return <NoImageIcon width={width} height={height} fill="#d5d5d5" stroke="#d5d5d5" />;
	}

	return <svg ref={containerRef} style={{ display: "none" }} />;
};

export default SvgComponent;
